import cx from 'classnames';
import { ReactNode, useEffect, useRef, useState } from 'react';
import { Tooltip } from '../tooltip';
import { TooltipProps } from '../tooltip/tooltip';
import styles from './TruncatedTextWithTooltip.module.scss';

interface IProps extends Partial<TooltipProps> {
  text: string | ReactNode;
  maxLines?: number;
  className?: string;
  tooltipClassname?: string;
  wrapperClassName?: string;
  maxTooltipCharactersNumber?: number;
}

const TruncatedTextWithTooltip = ({
  text,
  maxLines = 2,
  className,
  tooltipClassname,
  wrapperClassName,
  maxTooltipCharactersNumber,
  ...props
}: IProps) => {
  const textRef = useRef<HTMLDivElement>(null);
  const [isTruncated, setIsTruncated] = useState(false);

  const style = {
    WebkitLineClamp: maxLines,
  };

  useEffect(() => {
    const el = textRef.current;
    if (!el) return;

    const computedStyle = getComputedStyle(el);
    const lineHeight = parseFloat(computedStyle.lineHeight);
    const maxHeight = lineHeight * (maxLines || 2);

    const isHeightTruncated = el.scrollHeight > maxHeight;
    const isWidthTruncated = el.clientWidth < el.scrollWidth;

    setIsTruncated(isHeightTruncated || isWidthTruncated);
  }, [text, maxLines]);

  let tooltipContent = text;
  if (
    maxTooltipCharactersNumber &&
    typeof text === 'string' &&
    text.length > maxTooltipCharactersNumber
  ) {
    tooltipContent = text.slice(0, maxTooltipCharactersNumber) + '...';
  }

  const content = (
    <div className={cx(styles.wrapper, wrapperClassName)}>
      <div
        ref={textRef}
        className={cx(styles.cellText, className)}
        style={style}
      >
        {text}
      </div>
    </div>
  );

  return isTruncated ? (
    <Tooltip
      content={tooltipContent}
      className={cx(styles.tooltipContent, tooltipClassname)}
      {...props}
    >
      {content}
    </Tooltip>
  ) : (
    content
  );
};

export default TruncatedTextWithTooltip;
